var resizeTimer;

(function( $ ) {
	//  Anti Frame Busting
	if (self === top) {
  	var antiClickjack = document.getElementById("antiClickjack");
    antiClickjack.parentNode.removeChild(antiClickjack);
  }
	else {
    top.location = self.location;
  }

	var count=0;
	var slides = $('#main_hero .slides').children().first();

	if(slides.length)
	{
		slides.each(function()
		{
				var imgsource = $(this).find('.slideimg').data('src');
				$('<img/>').attr('src', imgsource).on('load', function()
				{
						$(this).remove();
						count++;

						if (count == slides.length)
						{
								$('#hideAll').fadeOut(500);
						}
				});
		});
	}

	else if($('.stretchimg').length)
	{
		$('<img/>').attr('src', $('.stretchimg').attr('src')).on('load', function()
		{
				$(this).remove();
				$('#hideAll').fadeOut(500);
		});
	}

	else
	{
		$('#hideAll').fadeOut(500);
	}

	if(window.location.href.indexOf("test=1") > -1 || window.location.href.indexOf("test=true") > -1) {
		$('#hideAll').fadeOut(500);
	}

		// store the slider in a local variable
		var $window = jQuery(window),
			spotlight,
			flipcards,
			flipcardsVars = {
				slideshow: false,
				animation: "slide",
				controlNav: false,
				pauseOnHover:true,
				animationLoop: true,
				itemWidth: 100,
				itemMargin: 20,
				minItems: getGridSize(), // use function to pull in initial value
				maxItems: getGridSize(), // use function to pull in initial value
				touch: true
			};

		// tiny helper function to add breakpoints
		function getGridSize() {
			return (window.innerWidth < 600) ? 1 : (window.innerWidth < 900) ? 2 : 3;
		}

		// Flip Card Slider
		flipcards = $('.flexslider-flipcards').flexslider(flipcardsVars);

	 	 // flexslider loader
		spotlight = $('.flexslider-slides').flexslider({
			animation: 'fade',
			controlNav: true,
			directionNav: false,
			pauseOnHover:true,
			touch: true
		});

		// check grid size on resize event
		$window.resize(function()
		{
			clearTimeout(resizeTimer);

		  	resizeTimer = setTimeout(function()
		  	{
	        	windowResize();
		  	}, 1);
		});

		if(window.innerWidth < 768)
		{
			// Flipcard Flip on Mobile
			$('#flip_card .flipper-card').bind('click', function(e)
			{
				e.preventDefault();
				$(this).children('a')[0].click();
			});

			// Get height of navigation and adjust site parts accordingly
			setTimeout(function() {
			    var headerHeight 	= $('#main-navigation').outerHeight();
			    $('.stretchimg').css('margin-top', headerHeight);
		    }, 250, this); // use a delay so everything is calculated correctly
		}

		$("#flip_card .flipper-card .backside").on('click', function() {
			window.location.href = $(this).find('a').attr('href');
		});

		// image gallery lazy load
		$("img.lazy").lazyload(
		{
		    threshold : 50,
		    effect : "fadeIn"
		});


		function windowResize()
		{
			if(flipcards.data("flexslider"))
			{
				var gridSize = getGridSize();

				flipcards.data("flexslider").vars.minItems = gridSize;
				flipcards.data("flexslider").vars.maxItems = gridSize;

				flipcards.resize();
			}

			// Get height of navigation and adjust site parts accordingly
		    var headerHeight 	= $('#main-navigation').outerHeight();
		    $('.stretchimg').css('margin-top', headerHeight);

		    spotlight.resize();

			var controlNav_BtmPosition = parseInt(spotlight.find('.flex-active-slide').find('.movie_info').outerHeight());
  			$('.flex-control-nav').css('bottom', controlNav_BtmPosition);
		}

	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	function scrollTo(selector, scrollDuration, includeHeader) {
		var offset = (includeHeader) ? $("#main-navigation").outerHeight() - 11 : 0;
		$("html, body").animate({
			scrollTop: $(selector).offset().top - offset
		}, scrollDuration);
	}

	// Theater Locator Pre-defined Search
	if(window.location.search.indexOf("tl_search") != -1 && $("#theater_locator").length) {
		var tl_search = getUrlParameter("tl_search");
		tl_search = tl_search.replace(/_/g, " ");
		scrollTo("#theater_locator", 1000, true);
		setTimeout(function(){
			$("#theater_locator_input").focus().val(tl_search);
			$("#theater_locator div.theater_locator_input_enter").trigger("click");
		}, 500);
	}

	// flipcard resize
	function flipcard_resize() {
		$('.flipcardwrapper').each(function() {
			var imgHeight = $(this).width();
			$(this).find('.flipper-card').height(imgHeight);
			if($(window).width() >= 768) {
				$(this).find('.flipper-textwrapper').height('calc(100% - '+imgHeight+')');
			} else {
				$(this).find('.flipper-textwrapper').height('auto');
			}
		});
	}

	// Document Ready
	$(document).ready(function()
	{
		// flipcard resize
		if(!$('body').hasClass('home')) {
			flipcard_resize();
			$(window).resize(flipcard_resize);
		}

		// Mobile Navigation :: Setup
		$('#main-navigation').after($('<div id="navbar-height-col"></div>'));

	    // Enter your ids or classes
	    var toggler = '.navbar-toggle';
	    var pagewrapper = '#mamawrapper';
	    var navigationwrapper = '.navbar-header';
	    var slidewidth = '100%';
	    var slideneg = '-100%';

    	$("#main-navigation").on("click load", toggler, function()
    	{
	        var selected = $(this).hasClass('slide-active');

	        $('#navbar-height-col').stop().animate({
	            left: selected ? slideneg : '0px'
	        });

	        $(navigationwrapper).stop().animate({
	            left: selected ? '0px' : slidewidth
	        });

        	$(this).toggleClass('slide-active', !selected);
        	$('#utility-nav').toggleClass('slide-active');

        	$(pagewrapper+', '+navigationwrapper+', .navbar, body').toggleClass('slide-active');
    	});

    	// Email Updates Link Click -- Open Form
    	$(document).on('click', 'li.nav_email_updates a', function()
    	{
	    	$('#nav-links').addClass('fadeHide');
	    	$('#email-updates-container').removeClass('fadeHide').addClass('open');
    	});

    	// Email Updates -- Form Close Btn
    	$(document).on('click', '#emailupdatesclosebtn', function()
    	{
	    	$('#email-updates-container').addClass('fadeHide').removeClass('open');
	    	$('#nav-links').removeClass('fadeHide');
    	});

		// Fixed Navbar Resize on scroll
		function checkScroll()
		{
		    var startY = $('.navbar').height() * 2; //The point where the navbar changes in px

		    if($(window).scrollTop() > startY){
		        $('.navbar').addClass("scrolled");
		    }else{
		        $('.navbar').removeClass("scrolled");
		    }
		}

		if($('.navbar').length > 0){
		    $(window).on("scroll load resize", function(){
		        checkScroll();
		    });
		}

		// activate smoothscroll
		$().SmoothAnchors();

		// Exhibitor collapse toggle
		//-------------------------------//
		$(window).on("resize load",function()
		{
			// gets height of download items to slide toggle them smoothly
			setTimeout(function()
			{
			    // get height of every child element
			    $( ".tablecat-body" ).each(function()
			    {
			        var newHeight = 0, $this = $( this );
			        $.each( $this.children(), function()
			        {
			            newHeight += $( this ).outerHeight(true)+12;
			        });

					// set max-height for this element
					$(this).css('max-height', newHeight)
				});
			}, 150);
		});

		// collapse toggles exhibitor post on click
		$('.tablecat-title').bind('click', function()
		{
			$(this).find('h1').toggleClass('active');
			$(this).siblings('.tablecat-body').toggleClass('collapse');
		});

		// tell first class to not have collapse on load
		// wrap in timeout function so we have time to calc height and set max-height property
		setTimeout(function()
		{
			$('.tablecat-group').slice(1).find('.tablecat-body').addClass('collapse');
			$('.tablecat-group').slice(1).find('.tablecat-title h1').removeClass('active');
		}, 350);

	    //Manual Move on click:
	    //-------------------------------//
	    $('.controls.down').click(function()
	    {
	        var target = $('.target').first();

	        $('html, body').stop().animate({
	              scrollTop: target.offset().top
	        }, 1200);
	        return false;
		});

		// FancyBox
		//-------------------------------//
		$(".galleryimg.fancybox").fancybox(
		{
			'transitionIn'		: 'elastic',
			'transitionOut'		: 'elastic',
			'cyclic'			: true,
			'autoScale'			: true,
			helpers : {
				title : {
					type: 'inside'
				},
				overlay: {
					locked: false,
					css : { 'overflow' : 'hidden' }
				}
			}
		});

		$(".galleryimg.fancybox").on('click', function(e) {
			e.preventDefault();
		})

		$(document).on('mouseover', '.socialicon-wrapper', function ()
		{
			$(this).addClass('active');
		});

		$(document).on('mouseout', '.socialicon-wrapper' ,function()
		{
			var $this = $(this);
			setTimeout(function() {
				$this.removeClass('active');
			}, 450);
		});

		$('.socialicon-wrapper').bind("touchstart",function()
		{
			$(this).toggleClass('active');
		});

		// Play video trailers
		//-------------------------------//
		$('.videoclip').bind("click",function(event)
		{
			// cancel re-making the iframe if it is active
			if($('#videowrapper').hasClass('activate'))
				event.preventDefault();

			// clear old iframes and ready the new
			$('#videowrapper iframe').remove();
			$('#videowrapper').addClass('activate');
			$('.fp-close').removeClass('scaleIn');

			// get iframe ID
			var videoID  = $(this).data("videoid");
			var provider = $(this).data("provider");

		    // create iframe
		    var ifrm = document.createElement("IFRAME");
			provider = ( provider == 'youtube' ? "https://www.youtube.com/embed/"+videoID+"?enablejsapi=1&wmode=opaque&rel=0&vq=hd1080&showinfo=1&autoplay=1&iv_load_policy=3" : "https://player.vimeo.com/video/"+videoID+"?autoplay=true" );

		       ifrm.setAttribute("src", provider);
		       ifrm.style.width = "100%";
		       ifrm.style.height = "100%";
		       // add rest of your values
		       ifrm.frameborder = 0;

			// hide site nav
			$('nav').hide();

			// append iframe to container
			setTimeout(function()
			{
				$('#videowrapper').append(ifrm);
		    	return false;
			}, 650, this);
		});

		$('.fp-close').bind("click touchstart",function()
		{
			$('#videowrapper').removeClass('activate');
			$('.fp-close').addClass('scaleIn');
			$('nav li.parent').removeClass('active');

			// show site nav
			$('nav').show();

			// append iframe to container
			setTimeout(function()
			{
				$('#videowrapper iframe').remove();
		    	return false;
			}, 650, this);
		});

		//-------------------------------//
		//  Is element in view function  //
		//-------------------------------//
		(function($)
		{
		  	$.fn.visible = function(partial)
		  	{
		      	var $t            = $(this),
					$w            = $(window),
					viewTop       = $w.scrollTop(),
					viewBottom    = viewTop + $w.height(),
					_top          = $t.offset().top,
					_bottom       = _top + $t.height(),
					compareTop    = partial === true ? _bottom : _top,
					compareBottom = partial === true ? _top : _bottom;

				return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
		  	};
		})(jQuery);

		var win = $(window);

		var allMods = $(".module");

		allMods.each(function(i, el)
		{
		  	el = $(el);

		  	if(el.visible(true))
		  	{
		    	el.addClass("already-visible");
		  	}
		});

		win.scroll(function()
		{
		  	allMods.each(function(i, el)
		  	{
		    	el = $(el);

				if(el.visible(true))
				{
					el.addClass("animate");
		    	}
		  	});
		});
	});

	//-------------------------------//
    //		Smooth Scroll   		 //
    //-------------------------------//
	$.fn.SmoothAnchors = function()
	{
		function scrollBodyTo(destination)
		{
			// Get height of header to offset navigation
			var navheight = $('header').outerHeight();

			if(navheight == 0)
				navheight = $('header nav').outerHeight(true);

			// Change the hash first, then do the scrolling. This retains the standard functionality of the back/forward buttons.
			var scrollmem = $(document).scrollTop();
			//window.location.hash = hash;
			$(document).scrollTop(scrollmem);
			$("html,body").animate({scrollTop:(parseInt(destination) - parseInt(navheight))}, 500);
		}

		if (typeof $().on == "function")
		{
			$(document).on('click', 'a[href^="#"]', function()
			{
				var href = $(this).attr("href");

				if ($(href).length == 0)
				{
					var nameSelector = "[name=" + href.replace("#", "") + "]";

					if (href == "#")
					{
						scrollBodyTo(0);
					}

					else if ($(nameSelector).length != 0)
					{
						scrollBodyTo($(nameSelector).offset().top);
					}

					else
					{
						// fine, we'll just follow the original link. gosh.
						window.location = href;
					}
				}

				else
					scrollBodyTo($(href).offset().top);

				return false;
			});
		}

		else
		{
			$('a[href^="#"]').click(function()
			{
				var href = $(this).attr("href");

				if ($(href).length == 0)
				{
					var nameSelector = "[name=" + href.replace("#", "") + "]";

					if (href == "#")
					{
						scrollBodyTo(0);
					}

					else if ($(nameSelector).length != 0)
					{
						scrollBodyTo($(nameSelector).offset().top);
					}

					else
					{
						// fine, we'll just follow the original link. gosh.
						window.location = href;
					}
				}

				else
					scrollBodyTo($(href).offset().top);

				return false;
			});
		}

		if(window.location.hash)
			scrollBodyTo($(window.location.hash).offset().top);
	};
})( jQuery );
